import React from 'react';
import NightAuditPage from '../pages/NightAudit';

/**
 * Night Audit Component - Wrapper for backward compatibility
 * Routes to the new Night Audit Page with step-by-step system
 * 
 * New Features:
 * - Step-by-step guided process
 * - Catch-up mode for missed audits
 * - Real-time data refresh
 * - Better state management
 * - Modern UI/UX
 */
function NightAudit({ user }) {
  return <NightAuditPage user={user} />;
}

export default NightAudit;
